import injectSheet from 'react-jss'
import InteractivePopUp from './InteractivePopUp'
import styles from './InteractivePopUp.styles'

export default injectSheet(styles)(InteractivePopUp)
